module.exports = __webpack_public_path__ + "static/img/20220507_02.00b886a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20220507_02.png
// module id = zpRp
// module chunks = 0